const CONSTANTS = {
  status_payment: {
    AWAITING_PAYMENT: 1, //Ждет оплаты
    PREPAYMENT_MADE: 2, //Внесена предоплата
    PAID_UP: 3, //Оплачен
    PREPAYMENT_REFUNDED: 4, //Предоплата возвращенна
  },
  status_system_order: {
    NEW: 1, //Новый заказ//id в таблице status_system_orders
    IN_THE_WORK: 2, // в работе//id в таблице status_system_orders
    RECEIVED_DELIVERED: 3, //Получен/Доставлен//id в таблице status_system_orders
    CANCELED: 4, //Отменен//id в таблице status_system_orders
    ON_THE_WAY: 5, //В пути//id в таблице status_system_orders
  },
  status_system_order_part: {
    PENDING: 1, //В ожидании//id в таблице status_system_order_parts
    IN_THE_WORK: 2, // в работе//id в таблице status_system_order_parts
    RECEIVED_DELIVERED: 3, //Получен/Доставлен//id в таблице status_system_order_parts
    ON_THE_WAY: 4, //В пути//id в таблице status_system_order_parts
    CANCELED: 5, //Отменен//id в таблице status_system_order_parts
    IN_STOCK: 7, //на складе //id в таблице status_system_order_parts
  },
  status_system_order_repairtime: {
    NEW: 1, //Новая //id в таблице status_system_order_repairtimes
    PLANNED: 2, // Запланировано //id в таблице status_system_order_repairtimes
    IN_THE_WORK: 3, // В работе //id в таблице status_system_order_repairtimes
    READY: 4, //Готово //id в таблице status_system_order_repairtimes
    CANCELED: 5, //Отменено //id в таблице status_system_order_repairtimes
    PENDING: 6, //В ожидании //id в таблице status_system_order_repairtimes
  },
};
export { CONSTANTS };
